import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';
import { useNavigate } from 'react-router-dom';
import { PropagateLoader } from 'react-spinners';
import { IoAddSharp } from "react-icons/io5";
import Pagination from '../pagination/pagination';
import { GrEdit } from "react-icons/gr";
import Select from 'react-select';
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import { FaRegEye } from "react-icons/fa6";
import { useSelector } from 'react-redux';
import { getCompany, getUserName } from '../../../Redux/selecters';
import { ClipLoader } from 'react-spinners';

const ApprovalListing = () => {
    const apiService = new ApiService();
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [permissions, setPermissions] = useState();
    let navigate = useNavigate();
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [selectedRow, setSelectedRow] = useState(null);
    const [Users, setUsers] = useState([]);
    const companies = useSelector(getCompany);

    const initialFormData = {
        userName: [{ label: 'Select UserName', value: 'Select User' }],
        doctype: [{ label: 'Select Doc Type', value: 'Select DocType' }],
    };

    const [formData, setFormData] = useState(initialFormData);

    const DocType = [
        { value: 'Purchase Requisition', label: 'Purchase Requisition' },
        { value: 'Price Comparison', label: 'Price Comparison' },
        { value: 'Store Requisition', label: 'Store Requisition' },
        { value: 'POrder', label: 'Purchase Order' },
        { value: 'I Return', label: 'Issue Return' },
        { value: 'I Receive', label: 'Issue Receive' },
        { value: 'PR', label: 'Purchase Return' },
        { value: 'Quotation', label: 'Quotation' },
        { value: 'GRN', label: 'GRN' },
        { value: 'Invoice', label: 'Invoice' },
        { value: 'Issue', label: 'Item Issue' },
        { value: 'Stock Adjustment', label: 'Stock Take' },
        { value: 'ADJ', label: 'Stock Adjustment' },
    ]
    useEffect(() => {
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        const permissions = storedPermissions?.filter(acc => acc.formName === "Approval User");
        setPermissions(permissions[0]);
    }, [pageSize]);
    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                let DB = localStorage.getItem('DataBase')
                let selectCompany = companies?.companies.find((comp) => comp.dataDB === DB)
                let param = `?Usr_Company=${selectCompany?.companyNo}`
                const UsersLis = await apiService.getApiParamater("GET_USERS_LIST", param);
                setUsers(UsersLis?.data?.result);
            } catch (error) {
                console.error('Error fetching dropdown data:', error);
            }
        };
        fetchDropdownData();
        getItems(1)
    }, []);
    const handleEdit = () => {
        if (selectedRow) {

            navigate(`/Inventory/ApprovalUser/${selectedRow?.rcid}`, { state: selectedRow });
        }
    };
    const handleEye = (clickedRowData) => {
        // if (permissions?.canView === true) {
        if (clickedRowData?.userNo) {
            const updatedData = { ...clickedRowData, eye: !clickedRowData.eye?.active };
            navigate(`/Inventory/ApprovalUser/${updatedData?.docType}/${updatedData?.userNo}`, { state: updatedData });
        } else if (selectedRow) {
            const updatedData = { ...selectedRow, eye: !selectedRow.eye?.active };
            navigate(`/Inventory/ApprovalUser/${updatedData?.docType}/${updatedData?.userNo}`, { state: updatedData });
        }
        // }
    }
    const onSelectionChanged = (event) => {
        const selectedRows = event.api.getSelectedRows();
        setSelectedRow(selectedRows.length === 1 ? selectedRows[0] : null);
    };
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoading(true);
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', 50);
            params.append('UserNo', formData?.userName?.label || "");
            params.append('DocType', formData?.doctype?.value || "");
            const res = await apiService.getApiParamater('GET_APPROVAL_USER', `?${params.toString()}`);
            setRowData(res?.data?.result || []);
            setPagination(res.data.paginationData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    };
    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, width: 50 },
        { headerName: 'User Name', field: 'userNo', suppressMovable: true, width: 220 },
        { headerName: 'User Role', field: 'itemDescription', suppressMovable: true, width: 220 },
        { headerName: 'Email', field: 'userNo', suppressMovable: true, width: 220 },
        { headerName: 'Doc Type', field: 'docType', suppressMovable: true, width: 220 },
        { headerName: 'Department', field: 'department', suppressMovable: true, width: 220 },
        { headerName: 'Approval  Level', field: 'userLevel', },
        {
            headerName: 'Status', field: 'active', suppressMovable: true, width: 180,
            cellRenderer: function (params) {
                if (params.value === 0 || params.value === null) {
                    return (<button class="btn pend ">In Active</button>);
                }
                else if (params.value === 1 || params.value === null) {
                    return (<button class="btn aproved">Active</button>);
                } else {
                    return params.value;
                }
            }
        },
    ];
    const onCellClicked = (event) => {
        if (event.colDef.field === 'itemNo') {
            const clickedRowData = event.data;
            setSelectedRow(clickedRowData);
            handleEye(clickedRowData)
        }
    };
    const handlenew = () => {
        navigate('/Inventory/ApprovalUser/Create');
    };
    const handleDocTypeChange = (selectedOption) => {
        setFormData({ ...formData, doctype: selectedOption });
    }
    const handleUsersDrop = (selectedOption) => {
        setFormData({
            ...formData,
            userName: selectedOption,
        });
    }

    const handleReset = () => {
        setFormData(initialFormData);
    };
    return (
        <div className='px-4 pt-3'>
            <div className='gridBg mx-1' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='row mt-2 d-flex jusitfy-content-end'>
                    <div className="col justify-content-around d-flex">
                        <label htmlFor="validationCustom02" className="form-label  pt-2 start">User Name</label>
                        <Select
                            value={formData.userName}
                            onChange={handleUsersDrop}
                            options={Users?.map((sup) => ({ value: sup, label: sup?.user_Name }))}
                            className="w-100 p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                        />
                    </div>
                    <div className="col d-flex justify-content-between">
                        <label htmlFor="validationCustom01" className="form-label  pt-2 start">Doc Type</label>
                        <Select
                            value={formData?.doctype}
                            options={DocType?.map((doc) => ({ value: doc?.value, label: doc?.label }))}
                            onChange={handleDocTypeChange}
                            className="w-100 p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                        />
                    </div>
                    <div className='col-2'>
                        <div
                            onClick={handleReset}
                            className="mainbtnRed flex-end gap-2"
                        >
                            <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                            <div className="center">Reset</div>
                        </div>
                    </div>
                    <div className='col-2'>
                        {loading === true ?
                            <button className='mainbtnGry w-100 ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                            <div onClick={() => getItems(1)} className='mainbtnGry flex-end gap-2'>
                                <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                                <div className='center'>Search</div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            {loading ? (
                <div className='center'>
                    <PropagateLoader color="#6E5199" size={15} />
                </div>
            ) : (
                <div className='gridBg mt-3'>
                    <div className='justify-content-between d-flex align-items-center pb-2 border-0'>
                        <h5 className='col mainInvHead'>Approval User List</h5>
                        <div className='d-flex gap-1'>
                            {permissions?.canUpdate === true ?
                                <div
                                    onClick={handleEdit}
                                    className={`mainbtnSecondary flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
                                    style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
                                >
                                    <GrEdit color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>Edit</div>
                                </div> : ""}
                            <div
                                onClick={handleEye}
                                className={`mainbtnGry flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
                                style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
                            >
                                <FaRegEye color='#fff' className='center mt-1' />
                                <div className='center'>View</div>
                            </div>
                            {permissions?.canAdd === true ?
                                <div onClick={handlenew} className='mainbtn flex-end gap-1'>
                                    <IoAddSharp color='#fff' className='center mt-1 mx-1' size={18} />
                                    <div className='center'>Add</div>
                                </div> : ""}
                        </div>
                    </div>
                    <div className="gridshad">
                        <div className="ag-theme-quartz" style={{ height: 570 }}>
                            <AgGridReact
                                getRowStyle={(params) => {
                                    return params.node.rowIndex % 2 === 0
                                        ? { background: '#F0EDF5' }
                                        : { background: '#fff' };
                                }}
                                rowData={rowData}
                                columnDefs={columnDefs}
                                pagination={false}
                                onSelectionChanged={onSelectionChanged}
                                onCellClicked={onCellClicked}
                            />
                        </div>
                    </div>
                    <Pagination setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
                </div>
            )}
        </div>
    );
};

export default ApprovalListing;